<script>
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsLayout from 'viralstyle-ui/src/VsLayout';
import VsModal from 'viralstyle-ui/src/VsModal';
import VsTable from 'viralstyle-ui/src/VsTable';
import { mapState } from 'vuex';

import DeductionsTable from './DeductionsTable';

export default {
  components: {
    VsLayout,
    VsModal,
    VsButton,
    VsTable,
    DeductionsTable,
  },
  mixins: [vueMixins],
  computed: mapState({
    processing: state => state.processing,
    currentPayoutDeductionsDetails: state => state.settings.currentPayoutDeductionsDetails,
  }),
};
</script>

<template lang='pug'>
vs-modal.details(v-if='currentPayoutDeductionsDetails', @close='$emit("close")', title='Payout Info')
  vs-layout(slot='body', wrap-xs, no-gutter)

    vs-layout(v-show='get(currentPayoutDeductionsDetails, "payment_method")', no-gutter, sm='6', lg='4', margin-bottom='1', wrap-xs)
      label.details__label Payment Mode
      h6.details__value {{get(currentPayoutDeductionsDetails, "payment_method")}}
    vs-layout(no-gutter, sm='6', lg='4', margin-bottom='1', wrap-xs)
      label.details__label Amount
      h6.details__value {{currency(get(currentPayoutDeductionsDetails, "amount"))}}

    vs-layout(v-for='(payout, index) in get(currentPayoutDeductionsDetails, "payouts")', no-gutter, margin-top='1', :key='index')
      deductions-table(:deductions='payout.deductions')

  div(slot='footer')
    vs-button(type='button', text='done', icon='check', @click='$emit("close")', :processing='processing', :disabled='processing')
</template>

<style>
@import '~import/index';
@import '~styles/index';

.details {
  &__label {
    @extend %text-transform;
    @extend %full-width;
    display: block;
    font-size: $h6;
    line-height: $h5;
  }

  &__value {
    @extend %word-break;
    line-height: $h5;
  }

  &__heading {
    line-height: $h4;
  }

  &__size {
    @extend %text-center;
  }

  &__half-cell {
    @include mq(mf-md) {
      width: 50%;
    }
  }

  .accordion-content {
    padding: 0;
    background-color: $white;

    >.vs-table:not(:first-child) {
      margin-top: 1rem;
    }
  }
}
</style>